<script setup>
import {ref} from "vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ContentWizardModal from "@/components/actions/partials/settings/ContentWizardModal.vue";

defineProps({
  hasKeywordsAssigned: {
    required: true,
    type: Boolean,
  },
  page: {
    required: true,
    type: Object,
  },
  buttonClasses: {
    required: false,
    type: [String, null],
    default: null,
  },
});

const open = ref(false);

const handleClose = () => {
  open.value = false;
}
</script>

<template>
  <VTooltip
    placement="bottom"
    theme="dark-blue-tooltip"
    :disabled="hasKeywordsAssigned"
    :delay="{ show: 0, hide: 500 }"
  >
    <DefaultButton
      class="!tw-py-2 !tw-px-4 !tw-rounded-lg tw-whitespace-nowrap"
      :class="buttonClasses"
      :disabled="!hasKeywordsAssigned"
      @click="open = true"
    >
      <svg-vue
        icon="icons/stars"
        class="tw-w-6 tw-h-6 tw-mr-2"
      />
      <span class="tw-font-semibold tw-antialiased">Content Wizard</span>
    </DefaultButton>

    <template #popper>
      Please
      <a
        href="/sitemap"
        style="color: #0094FF; font-weight: bold"
      >
        assign keywords
      </a> to this page to enable content wizard
    </template>
  </VTooltip>

  <ContentWizardModal
    v-if="open"
    :page="page"
    @close="handleClose"
  />
</template>

